import { useQuery, QueryOptions, useMutation } from 'react-query'
import { fetchChangelog, fetchInstallationStatus, fetchLatestInstallationState, fetchNotificationData, fetchRollbackListOption } from '../api'
import { NotificationDataResponse, ReleaseType, ResourceType } from '../interfaces/notification-data.interface'

export const getNotificationDataQueryKeys = (isCheckSoftwareUpdate?: boolean) => ['api', isCheckSoftwareUpdate ? 'checkSoftwareUpdate' : 'notificationData']

export const getRollbackOptionListQueryKeys = () => ['api', 'rollbackListOption']

export const getChangelogQueryKeys = (type: ResourceType, version: string, releaseType: ReleaseType) => ['api', 'settings', 'changeLog', type, version, releaseType]

export const useQueryGetNotificationData = (isCheckSoftwareUpdate?: boolean, options?: QueryOptions) => useQuery(
    getNotificationDataQueryKeys(isCheckSoftwareUpdate), async () => {
        const res = await fetchNotificationData(isCheckSoftwareUpdate) as any
        return res as NotificationDataResponse
    }, options)

export const useQueryChangelog = (type: ResourceType, version: string, releaseType: ReleaseType, hwVersion: string) => useQuery(
    getChangelogQueryKeys(type, version, releaseType), async () => {
        const res = await fetchChangelog(type, version, releaseType, hwVersion)
        return res
    }, {
    cacheTime: 0,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
})

export const useQueryGetRollbackListOption = () => useQuery(
    getRollbackOptionListQueryKeys(), async () => {
        const res = await fetchRollbackListOption() as any
        return res as any
    })

export const useQueryGetInstallationStatus = (options?) => useQuery(
    ['api', 'about', 'installationstatus'], async () => {
        const res = await fetchInstallationStatus() as any

        const result = await res.text();
        return result
    }, {
    refetchInterval: options?.refetchInterval
})

export const useMutationGetInstallationStatus = () => useMutation(async () => {
        const res = await fetchInstallationStatus() as any

        const result = await res.text();
        return result
    })


export interface LatestInstallationInfo {
    UpdateType: string;
    InstallationMode: string;
    InstallationFilename: string;
    InstallationType: string;
    InstallationStatus: string;
    InstallationHwVersion: string;
    InstallationReleaseType: string;
}

export const useQueryGetLatestInstallationInfo = () => useQuery(
    ['api', 'about', 'latestInstallationState'], async () => {
        const res = await fetchLatestInstallationState() as any
        return await res.json() as LatestInstallationInfo
    }, {
    refetchInterval: 1000 * 60 * 3 // refetch every 3 minutes
})